import { gql } from '@apollo/client';

export const PLAN_OWNER_CREATE = gql`
  mutation PlanOwnerCreate(
    $name: String!
    $ceo: String
    $phone: String
    $email: String!
    $webSite: String
    $about: String
    $logo: String
    $photos: [String!]
    $recommendedBy: [String!]
    $specifications: JSON
  ) {
    planOwnerCreate(
      name: $name
      ceo: $ceo
      phone: $phone
      email: $email
      webSite: $webSite
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const PLAN_OWNER_UPDATE = gql`
  mutation PlanOwnerUpdate(
    $id: ID!
    $name: String!
    $phone: String
    $email: String!
    $webSite: String
    $ceo: String
    $about: String
    $logo: String
    $photos: [String!]
    $recommendedBy: [String!]
    $specifications: JSON
  ) {
    planOwnerUpdate(
      id: $id
      name: $name
      phone: $phone
      email: $email
      webSite: $webSite
      ceo: $ceo
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const PLAN_OWNER_DELETE = gql`
  mutation RemovePlanOwner($id: ID!) {
    removePlanOwner(id: $id)
  }
`;
